/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { contentsRequestEstimateControllerCreate } from '../fn/contents-request-estimate/contents-request-estimate-controller-create';
import { ContentsRequestEstimateControllerCreate$Params } from '../fn/contents-request-estimate/contents-request-estimate-controller-create';
import { contentsRequestEstimateControllerDelete } from '../fn/contents-request-estimate/contents-request-estimate-controller-delete';
import { ContentsRequestEstimateControllerDelete$Params } from '../fn/contents-request-estimate/contents-request-estimate-controller-delete';
import { contentsRequestEstimateControllerFindByContentsRequestId } from '../fn/contents-request-estimate/contents-request-estimate-controller-find-by-contents-request-id';
import { ContentsRequestEstimateControllerFindByContentsRequestId$Params } from '../fn/contents-request-estimate/contents-request-estimate-controller-find-by-contents-request-id';
import { contentsRequestEstimateControllerFindById } from '../fn/contents-request-estimate/contents-request-estimate-controller-find-by-id';
import { ContentsRequestEstimateControllerFindById$Params } from '../fn/contents-request-estimate/contents-request-estimate-controller-find-by-id';
import { contentsRequestEstimateControllerUpdate } from '../fn/contents-request-estimate/contents-request-estimate-controller-update';
import { ContentsRequestEstimateControllerUpdate$Params } from '../fn/contents-request-estimate/contents-request-estimate-controller-update';
import { ContentsRequestEstimateDto } from '../models/contents-request-estimate-dto';

@Injectable({ providedIn: 'root' })
export class ContentsRequestEstimateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contentsRequestEstimateControllerFindByContentsRequestId()` */
  static readonly ContentsRequestEstimateControllerFindByContentsRequestIdPath = '/api/contents-request-estimate/{id}/contentsRequest';

  /**
   * 콘텐츠 의뢰 ID 기반 조회.
   *
   * 콘텐츠 의뢰 견적을 콘텐츠 의뢰 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestEstimateControllerFindByContentsRequestId()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestEstimateControllerFindByContentsRequestId$Response(params: ContentsRequestEstimateControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestEstimateDto>> {
    return contentsRequestEstimateControllerFindByContentsRequestId(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 ID 기반 조회.
   *
   * 콘텐츠 의뢰 견적을 콘텐츠 의뢰 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestEstimateControllerFindByContentsRequestId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestEstimateControllerFindByContentsRequestId(params: ContentsRequestEstimateControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<ContentsRequestEstimateDto> {
    return this.contentsRequestEstimateControllerFindByContentsRequestId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestEstimateDto>): ContentsRequestEstimateDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestEstimateControllerFindById()` */
  static readonly ContentsRequestEstimateControllerFindByIdPath = '/api/contents-request-estimate/{id}';

  /**
   * 콘텐츠 의뢰 견적 ID 기반 조회.
   *
   * 콘텐츠 의뢰 견적을 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestEstimateControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestEstimateControllerFindById$Response(params: ContentsRequestEstimateControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestEstimateDto>> {
    return contentsRequestEstimateControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 견적 ID 기반 조회.
   *
   * 콘텐츠 의뢰 견적을 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestEstimateControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestEstimateControllerFindById(params: ContentsRequestEstimateControllerFindById$Params, context?: HttpContext): Observable<ContentsRequestEstimateDto> {
    return this.contentsRequestEstimateControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestEstimateDto>): ContentsRequestEstimateDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestEstimateControllerDelete()` */
  static readonly ContentsRequestEstimateControllerDeletePath = '/api/contents-request-estimate/{id}';

  /**
   * 콘텐츠 의뢰 견적 삭제.
   *
   * 콘텐츠 의뢰 견적을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestEstimateControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestEstimateControllerDelete$Response(params: ContentsRequestEstimateControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestEstimateDto>> {
    return contentsRequestEstimateControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 견적 삭제.
   *
   * 콘텐츠 의뢰 견적을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestEstimateControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestEstimateControllerDelete(params: ContentsRequestEstimateControllerDelete$Params, context?: HttpContext): Observable<ContentsRequestEstimateDto> {
    return this.contentsRequestEstimateControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestEstimateDto>): ContentsRequestEstimateDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestEstimateControllerUpdate()` */
  static readonly ContentsRequestEstimateControllerUpdatePath = '/api/contents-request-estimate/{id}';

  /**
   * 콘텐츠 의뢰 견적 수정.
   *
   * 콘텐츠 의뢰 견적을 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestEstimateControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestEstimateControllerUpdate$Response(params: ContentsRequestEstimateControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestEstimateDto>> {
    return contentsRequestEstimateControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 견적 수정.
   *
   * 콘텐츠 의뢰 견적을 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestEstimateControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestEstimateControllerUpdate(params: ContentsRequestEstimateControllerUpdate$Params, context?: HttpContext): Observable<ContentsRequestEstimateDto> {
    return this.contentsRequestEstimateControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestEstimateDto>): ContentsRequestEstimateDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestEstimateControllerCreate()` */
  static readonly ContentsRequestEstimateControllerCreatePath = '/api/contents-request-estimate';

  /**
   * 콘텐츠 의뢰 견적 생성.
   *
   * 콘텐츠 의뢰 견적을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestEstimateControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestEstimateControllerCreate$Response(params: ContentsRequestEstimateControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestEstimateDto>> {
    return contentsRequestEstimateControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 견적 생성.
   *
   * 콘텐츠 의뢰 견적을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestEstimateControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestEstimateControllerCreate(params: ContentsRequestEstimateControllerCreate$Params, context?: HttpContext): Observable<ContentsRequestEstimateDto> {
    return this.contentsRequestEstimateControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestEstimateDto>): ContentsRequestEstimateDto => r.body)
    );
  }

}
